import React, { useState, useRef, useEffect } from 'react';
import { useLocalization } from '../context/LocalizationContext';

const languages = [
  { code: 'en-US', name: 'English' },
  { code: 'pt-BR', name: 'Português' },
  { code: 'es-419', name: 'Español' },
];

const getFlagUrl = (langCode) => {
  switch(langCode) {
    case 'en-US':
      return 'https://flagcdn.com/w40/us.png'; // US Flag
    case 'pt-BR':
      return 'https://flagcdn.com/w40/br.png'; // Brazil Flag
    case 'es-419':
      return 'https://flagcdn.com/w40/mx.png'; // Mexico Flag for LATAM Spanish
    default:
      return '';
  }
};

const LanguageSelector = () => {
  const { locale, setLocale } = useLocalization();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedLanguage = languages.find(lang => lang.code === locale);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center p-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      >
        <img src={getFlagUrl(locale)} alt={`${selectedLanguage.name} flag`} className="w-6 h-auto mr-2" />
        <span className="text-sm font-medium text-gray-700">{selectedLanguage.name}</span>
        <svg className={`w-5 h-5 ml-2 -mr-1 text-gray-400 transform transition-transform ${isOpen ? 'rotate-180' : ''}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10">
          <ul className="py-1">
            {languages.map((lang) => (
              <li key={lang.code}>
                <button
                  onClick={() => {
                    setLocale(lang.code);
                    setIsOpen(false);
                  }}
                  className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <img src={getFlagUrl(lang.code)} alt={`${lang.name} flag`} className="w-6 h-auto mr-3" />
                  <span>{lang.name}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
